import axios from 'axios';
import { PublicStatus } from '../types';

/**
 * The status page is reachable without a session, so this client sends no
 * credentials and shares nothing with the authenticated one.
 */
export const getPublicStatus = (slug?: string) =>
  axios.get<PublicStatus>(slug ? `/api/public/status/${encodeURIComponent(slug)}` : '/api/public/status', { withCredentials: true }).then(r => r.data);

/** Enter a passcode for a passcode-protected page; sets the guest cookie. */
export const verifyPagePasscode = (code: string) =>
  axios.post<{ pages: { slug: string; title: string }[]; page_scoped: boolean }>('/api/v2/guest/verify', { code }, { withCredentials: true }).then(r => r.data);
